import cls from 'classnames';
import { SearchBar } from 'antd-mobile';
import styles from './index.module.scss';
export default (props: Record<string, any>) => {
  const { onSearch } = props;
  return (
    <div className={styles['menu-list']}>
      <SearchBar onSearch={(val) => onSearch?.(val)} className={styles['menu-search']} />
    </div>
  );
};
